import {
  Austria,
  Belgium,
  Czechia,
  Denmark,
  France,
  Germany,
  Lithuania,
  Luxembourg,
  Netherlands,
  Poland,
  Switzerland,
} from '@gds/Icons';

export const months = [
  { label: 'Januar', value: '1' },
  { label: 'Februar', value: '2' },
  { label: 'März', value: '3' },
  { label: 'April', value: '4' },
  { label: 'Mai', value: '5' },
  { label: 'Juni', value: '6' },
  { label: 'Juli', value: '7' },
  { label: 'August', value: '8' },
  { label: 'September', value: '9' },
  { label: 'Oktober', value: '10' },
  { label: 'November', value: '11' },
  { label: 'Dezember', value: '12' },
];

export const countries = [
  { label: 'Deutschland', value: '1', leftContent: <Germany /> },
  { label: 'Österreich', value: '2', leftContent: <Austria /> },
  { label: 'Schweiz', value: '17', leftContent: <Switzerland /> },
  { label: 'Dänemark', value: '10', leftContent: <Denmark /> },
  { label: 'Polen', value: '19', leftContent: <Poland /> },
  { label: 'Litauen', value: '34', leftContent: <Lithuania /> },
  { label: 'Tschechien', value: '23', leftContent: <Czechia /> },
  { label: 'Frankreich', value: '5', leftContent: <France /> },
  { label: 'Niederlande', value: '6', leftContent: <Netherlands /> },
  { label: 'Belgien', value: '3', leftContent: <Belgium /> },
  { label: 'Luxemburg', value: '4', leftContent: <Luxembourg /> },
];
